import { createElementBlock, openBlock } from "vue";
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const _sfc_main = {};
const _hoisted_1 = { class: "header-item-spacer" };
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("span", _hoisted_1);
}
const HeaderItemSpacer = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  HeaderItemSpacer as default
};
//# sourceMappingURL=HeaderItemSpacer.vue.js.map
